import { z } from 'zod';

/** Data de calendário sem fuso, no formato AAAA-MM-DD. */
export const IsoDate = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Use o formato AAAA-MM-DD.')
  .refine((s) => !Number.isNaN(Date.parse(`${s}T00:00:00Z`)), 'Data inválida.');
export type IsoDate = z.infer<typeof IsoDate>;

/** Código IATA de aeroporto (GRU) ou de área metropolitana (SAO). */
export const PlaceCode = z
  .string()
  .trim()
  .toUpperCase()
  .regex(/^[A-Z]{3}$/, 'Código de aeroporto com 3 letras.');

/** Valores em reais, sem centavos (a marca não mostra casas decimais). */
export const Money = z.number().int().nonnegative();

export const Id = z.string().min(1).max(64);

export const PriceLevel = z.enum(['low', 'typical', 'high']);
export type PriceLevel = z.infer<typeof PriceLevel>;

export const Confidence = z.enum(['baixa', 'moderada', 'alta']);
export type Confidence = z.infer<typeof Confidence>;

/** Formato único de erro de toda a API. `fields` traz mensagens por campo quando a validação falha. */
export const ApiError = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    fields: z.record(z.string()).optional(),
  }),
});
export type ApiError = z.infer<typeof ApiError>;
